import { render, staticRenderFns } from "./the-client-legacy-bullhorn-data-container.vue?vue&type=template&id=708b7be7"
import script from "./the-client-legacy-bullhorn-data-container.vue?vue&type=script&lang=js"
export * from "./the-client-legacy-bullhorn-data-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports